export default {
    addListener: () => { },
    removeListeners: () => { },
};
//# sourceMappingURL=NotificationScheduler.js.map